/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'
import moment from 'moment'

import {
  IdentityClientInput
  // TODO: add ProgressIndicator
} from '../'

import {
  IDENTITY_DANELL
} from '../../constants'

class ClientAdd extends React.Component {
  static propTypes = {
    employer: PropTypes.object.isRequired,
    onCancel: PropTypes.func,
    onIdentityAdd: PropTypes.func,
    onClientAdd: PropTypes.func,
    className: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.state = {
      identity: null
    }
  }

  // create case to double-check newly added client details/relations
  createCase = () => {
    this.props
      .createCase({
        variables: {
          input: {
            affects: this.state.identity, // client identity
            openedBy: localStorage.getItem("userUUID"),
            assignedTo: IDENTITY_DANELL,
            priority: "b",
            productType: "picsaaccount",
            requestType: "Employer Confirmation Required",
            status: "open",
            nextActionAt: moment()
              .add(1, "days")
              .hour(16)
              .minute(0)
              .utc()
              .format("YYYY-MM-DD HH:mm:ss.SSS"),
          },
        },
      })
      .then(({ data }) => {
        console.log("case for client details follow-up created successfully");
        let input = {
          case: data.caseMutate.case.id,
          direction: "internal",
          note: "New client added on import, please validate and activate.",
          author: localStorage.getItem("userUUID"),
        };
        this.props
          .createCaseNote({ variables: { input } })
          .then(() => console.log("case note created successfully"))
          .catch(() => console.log("case note creation failed"));
      })
      .catch((error) =>
        console.log("case creation for client details follow-up failed", error)
      );
  }

  render() {
    return (
      <IdentityClientInput
        heading="Fill in new client identity information:"
        className={this.props.className}
        employer={this.props.employer}
        onSave={(identityObj, client) => {
          this.setState({ identity: identityObj.id})
          if (this.props.onIdentityAdd) {
            this.props.onIdentityAdd(identityObj)
          }
          if (this.props.onClientAdd) {
            this.props.onClientAdd(client)
          }
        }}
        onCancel={this.props.onCancel}
      />
    )
  }
}

const createCase = gql`
  mutation createCase($input: CaseMutationInput!) {
    caseMutate(input: $input) {
      case {
        ...CaseInformation
      }
    }
  }
  ${fragments.caseInformation}
`

const createCaseNote = gql`
  mutation createCasenote($input: CaseNoteMutationInput!) {
    casenoteMutate(input: $input) {
      casenote {
        ...CaseNote
      }
    }
  }
  ${fragments.casenote}
`

const withCaseMutate =
  graphql(createCase, {
    name: 'createCase'
  })

const withCaseNoteMutate =
  graphql(createCaseNote, {
    name: 'createCaseNote'
  })

export default compose(
  withCaseMutate,
  withCaseNoteMutate
)(ClientAdd)



// WEBPACK FOOTER //
// ./src/components/client-add/index.js